//this context is for keeping track of what page the user is currently in.
//it only tracks when a user is in a catalo
import { createContext } from "react";
const PageContext = createContext({
	currentPage: {},
	setCurrentPage: (page) => {}
});
export default PageContext;
